<template>
  <div>
    <v-dialog v-model="modalAberto" max-width="800">
      <div class="nota-dia-modal">
        <div class="modal-header">
          <div class="header-content">
            <div class="header-left">
              <div class="header-icon">
                <v-icon>mdi-note</v-icon>
              </div>
              <div class="header-text">
                <h2 class="header-title">Nota do dia</h2>
                <p class="header-subtitle">{{ dataAtual }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="unified-content">
          <v-card class="unified-card">
            <div class="form-content">
              <v-textarea
                class="modern-textarea"
                outlined
                name="input-7-1"
                label="Descrição"
                v-model="notaDia.descricao"
                rows="6"
                auto-grow
                counter
                maxlength="500"
              ></v-textarea>
            </div>
            <div class="form-actions">
              <div class="actions-container">
                <v-btn
                  class="action-btn delete-btn"
                  :disabled="notaDia.descricao === '' || !notaDiaExistente"
                  @click="excluir()"
                >
                  <v-icon left>mdi-minus-circle</v-icon>
                  Excluir
                </v-btn>
                <v-btn class="action-btn cancel-btn" :class="'warning'" @click="modalAberto = false">
                  <v-icon left>mdi-cancel</v-icon>
                  Cancelar
                </v-btn>
                <v-btn class="action-btn save-btn" @click="salvar()">
                  <v-icon left>mdi-content-save-check</v-icon>
                  Salvar
                </v-btn>
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import moment from 'moment';
import NotaDia from '../../models/agenda/NotaDia';
import { NotaDiaService } from '../../services/NotaDiaService';
import { AlertaSimples, AlertaSimplesErro } from '../../helpers/MensagemHelper';

export default Vue.component('soi-modalNotaDia', {
  data() {
    return {
      dataCalendario: new Date(Date.now()).toISOString().substr(0, 10),
      modalAberto: false,
      notaDia: new NotaDia(),
      notaDiaService: new NotaDiaService(),
      idAgenda: 1,
      dataAtual: '',
      notaDiaExistente: false,
    };
  },

  methods: {
    async abrirModalNota(idAgenda: number, Data: string) {
      this.notaDia = new NotaDia();
      this.notaDia.agendaId = idAgenda;
      this.notaDia.data = Data;
      this.idAgenda = idAgenda;
      await this.carregarNotaDiaExistente(idAgenda, Data);
      this.modalAberto = true;
    },

    async carregarNotaDiaExistente(idAgenda: number, data: string) {
      try {
        const response = await this.notaDiaService.GetNotaDoDia(idAgenda, data);
        this.notaDiaExistente = true;
        this.notaDia = response.data;
      } catch (error) {
        if (error.response.status === 404) {
          this.notaDiaExistente = false;
        }
      }
    },

    async salvar() {
      try {
        let response;
        if (this.notaDia.descricao === '') {
          AlertaSimples('Atenção', 'Não é possível salvar uma nota do dia vazia. Por favor, preencha a nota antes de salvá-la!', 'error');
          return;
        }
        if (this.notaDiaExistente) {
          response = await this.notaDiaService.Put(this.notaDia.id, this.notaDia);
        } else {
          response = await this.notaDiaService.Post(this.notaDia);
        }
        this.primeiraVez = false;
        this.notaDia = response.data;
        this.notaDia.data = moment(this.notaDia.data).format('YYYY-MM-DD');
        this.modalAberto = false;
        this.$emit('nota-salva', this.notaDia);
      } catch (error) {
        AlertaSimplesErro('Erro', 'Ocorreu um erro ao salvar a nota do dia. Por favor, tente novamente mais tarde.');
      }
    },

    async excluir() {
      if (!this.notaDia) {
        throw new Error('Nota não encontrada.');
      }
      await this.notaDiaService.Delete(this.notaDia.id);
      this.modalAberto = false;
      this.notaDia = new NotaDia();
      this.$emit('nota-salva', this.notaDia);
    },
  },
});
</script>

<style scoped>
/* === MODAL PRINCIPAL === */
.nota-dia-modal {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.modal-header {
  background: var(--especialidade-primary, #2e4b9d);
  color: white;
  padding: 24px 32px;
  position: relative;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.header-title {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  color: white;
}

.header-subtitle {
  font-size: 14px;
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
}

/* === CONTEÚDO UNIFICADO === */
.form-content {
  padding: 24px;
}

.modern-textarea {
  border-radius: 12px !important;
}

.modern-textarea .v-input__control .v-input__slot {
  border-radius: 12px !important;
  border: 2px solid #e9ecef !important;
  transition: all 0.3s ease !important;
}

.modern-textarea .v-input__control .v-input__slot:hover {
  border-color: var(--especialidade-primary, #2e4b9d) !important;
}

.modern-textarea .v-input__control .v-input__slot--focused {
  border-color: var(--especialidade-primary, #2e4b9d) !important;
  box-shadow: 0 0 0 3px rgba(46, 75, 157, 0.1) !important;
}

/* === AÇÕES === */
.form-actions {
  background: #f8f9fa;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}

.actions-container {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.action-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  padding: 0 24px !important;
  height: 48px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s ease !important;
}

.action-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2) !important;
}

.cancel-btn .v-icon {
  color: #ffffff !important;
}

.cancel-btn:hover {
  background: var(--especialidade-gradient, #2e4b9d) !important;
  color: #ffffff !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.delete-btn {
  background: #dc3545 !important;
  color: white !important;
}

.delete-btn:hover {
  background: #a51c2a !important;
}

.delete-btn:disabled {
  background: #e9ecef !important;
  color: #6c757d !important;
  box-shadow: none !important;
  transform: none !important;
}

.save-btn {
  background: var(--especialidade-primary, #2e4b9d) !important;
  color: white !important;
}

.save-btn:hover {
  background: var(--especialidade-secondary, #4a6cf7) !important;
}

/* === RESPONSIVIDADE === */
@media (max-width: 768px) {
  .nota-dia-modal {
    margin: 16px;
    border-radius: 16px;
  }

  .modal-header {
    padding: 20px 24px;
  }

  .header-title {
    font-size: 20px;
  }

  .unified-content {
    padding: 24px;
  }

  .form-content {
    padding: 16px;
  }

  .form-actions {
    padding: 20px 24px;
  }

  .actions-container {
    flex-direction: column;
    gap: 8px;
  }

  .action-btn {
    width: 100%;
  }
}
</style>
